<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营管理</el-breadcrumb-item>
      <el-breadcrumb-item>签到</el-breadcrumb-item>
      <el-breadcrumb-item>签到列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input
            v-model="queryInfo.id"
            placeholder="请输入签到编号"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="queryInfo.isStatus"
            placeholder="请选择状态"
            clearable
          >
            <el-option value="1" label="有效">有效</el-option>
            <el-option value="0" label="无效">无效</el-option>
          </el-select>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="getSignList">查询</el-button>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="openDialog">新增</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableInfo.tableData" border style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableInfo.columns"
          :prop="item.prop"
          :label="item.label"
          :align="item.align"
          :key="index"
        >
          <template slot-scope="scope">
            <span v-if="item.prop == 'startTime'">{{
                scope.row[item.prop] | filterTime
              }}</span>
            <span v-else-if="item.prop == 'endTime'">{{
                scope.row[item.prop] | filterTime
              }}</span>
            <el-image
              v-else-if="
                item.prop == 'icon'
              "
              :src="scope.row[item.prop]"
              :preview-src-list="[scope.row[item.prop]]"
            >
              <!-- <div slot="error" class="image-slot">
                <span>-</span>
              </div> -->
            </el-image>
            <span v-else-if="item.prop == 'isStatus'">{{
                scope.row[item.prop] | filterStatus
              }}</span>
            <span v-else-if="item.prop == 'rewardType'">{{
                scope.row[item.prop] | filterRewardType
              }}</span>
            <span v-else-if="item.prop == 'isRepair'">{{
                scope.row[item.prop] | filterIsRepair
              }}</span>
            <span v-else-if="item.prop == 'doubleType'">{{
                scope.row[item.prop] | filterDoubleType
              }}</span>
            <div v-else-if="item.prop == 'operation'">
              <el-button type="primary"
                         @click="openDialog(scope.row)">
                <i class="el-icon-edit"></i>
              </el-button>

              <el-button type="primary"
                         @click="deleteSign(scope.row.id)">
                <i class="el-icon-delete"></i>
              </el-button>
            </div>
            <!-- <span v-else-if="scope.row[item.prop] == null ">-</span> -->
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationInfo.pageNum"
        :page-sizes="[10, 30, 50]"
        :page-size="paginationInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationInfo.total"
      >
      </el-pagination>
    </el-card>

    <el-dialog
      width="30%"
      :title="dialogInfo.title"
      :visible="dialogInfo.visible"
      @close="dialogInfo.visible = false"
      :destroy-on-close="true"
    >
      <el-form
        ref="activityForm"
        :model="dialogInfo.formData"
        :rules="dialogInfo.rules"
        :label-position="'right'"
        label-width="100px"
        element-loading-text="正在上传中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form-item
          :label="item.label"
          :prop="item.prop"
          v-for="(item, index) in dialogInfo.formInfo"
          :key="index"
        >
          <!-- 活动时间选择 -->
          <el-date-picker
            v-if="item.type == '1'"
            v-model="dialogInfo.formData[item.prop]"
            :type="item.timeType"
            :range-separator="item.rangeStr"
            :start-placeholder="item.startPlaceholder"
            :end-placeholder="item.endPlaceholder"
            :placeholder="item.placeholder"
            :value-format="item.format"
            :format="item.format"
            clearable
          >
          </el-date-picker>

          <!-- 文件上传 -->
          <el-upload
            v-else-if="item.type == '2'"
            class="upload-demo"
            action=""
            :limit="1"
            :http-request="myUplaod"
            :on-remove="removeFile"
            :data="{ name: item.prop }"
          >
            <el-button size="small" type="primary">上传文件</el-button>
          </el-upload>

          <!-- 输入 -->
          <el-input
            v-else-if="item.type == '3'"
            v-model="dialogInfo.formData[item.prop]"
          ></el-input>

          <!-- 下拉 -->
          <el-select
            v-else-if="item.type == '4'"
            v-model="dialogInfo.formData[item.prop]"
            placeholder="请选择"
          >
            <el-option
              v-for="it in item.options"
              :key="it.value"
              :label="it.label"
              :value="it.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogInfo.visible = false">取 消</el-button>
        <el-button type="primary" @click="addActivity">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {

      // 输入框搜索
      queryInfo: {
        id: "",
        type: "",
        isStatus:"",
      },

      // 表格数据
      tableInfo: {
        columns: [
          { label: "编号", prop: "id", width: 150, align: "center" },
          { label: "天数", prop: "day",  align: "center" },
          { label: "开始时间", prop: "startTime", align: "center" },
          { label: "结束时间", prop: "endTime",  align: "center" },
          { label: "状态", prop: "isStatus",  align: "center" },
          { label: "奖励类型", prop: "rewardType",  align: "center" },
          { label: "精灵名称", prop: "rewardName",  align: "center" },
          { label: "奖励数量", prop: "rewardNum", align: "center" },
          { label: "是否可补签", prop: "isRepair", align: "center" },
          { label: "消耗数量", prop: "consumeNum", align: "center" },
          { label: "加倍奖励类型", prop: "doubleType", align: "center" },

          { label: "编辑", prop: "operation", width: 300, align: "center" },
        ],
        tableData: [],
      },

      // 分页数据
      paginationInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      // 弹窗数据
      dialogInfo: {
        visible: false,
        title: "新增签到",
        formInfo: [
          {
            type: 1,
            label: "开始时间",
            prop: "startTime",
            timeType: "date",
            placeholder:"请选择开始时间",
            value: "",
            format: "yyyy-MM-dd",
          },
          {
            type: 1,
            label: "签到结束时间",
            prop: "endTime",
            timeType: "date",
            value: "",
            format: "yyyy-MM-dd",
          },
          /*{
            type: 2,
            label: "图标",
            prop: "icon",
          },*/

          {
            type: 4,
            label: "状态",
            prop: "isStatus",
            options: [
              { label: "无效", value: 0 },
              { label: "有效", value: 1 },
            ],
          },
          {
            type: 4,
            label: "奖励类型",
            prop: "rewardType",
            options: [
              { label: "伏特", value: 1 },
              { label: "精灵", value: 2 },
            ],
          },
          {
            type: 3,
            label: "奖品id",
            prop: "rewardId",
          },
          {
            type: 3,
            label: "奖励数量",
            prop: "rewardNum",
          },
          {
            type: 3,
            label: "天数",
            prop: "day",
          },

          {
            type: 4,
            label: "是否可补签",
            prop: "isRepair",
            options: [
              { label: "是", value: 1 },
              { label: "否", value: 0 },
            ],
          },
          {
            type: 3,
            label: "补签消耗的数量",
            prop: "consumeNum",
          },
          {
            type: 4,
            label: "加倍奖励类型",
            prop: "doubleType",
            options: [
              { label: "无", value: 0 },
              { label: "看广告翻倍", value: 1 },
            ],
          },
        ],
        rules: {
         startTime: [
            { required: true, message: "请选择签到开始时间", trigger: "change" },
          ],
          endTime: [
            { required: true, message: "请选择签到结束时间", trigger: "change" },
          ],
          day: [
            { required: true, message: "请输入奖品获取天数", trigger: "blur" },
          ],
          rewardType: [
            { required: true, message: "请选择奖励类型", trigger: "blur" },
          ],
          rewardId: [
            { required: true, message: "请输入奖励id", trigger: "blur" },
          ],
          rewardNum: [
            { required: true, message: "请输入奖励数量", trigger: "blur" },
          ],
          isStatus: [
            { required: true, message: "请选择状态", trigger: "change" },
          ],
          isRepair: [
            { required: true, message: "请选择是否补签", trigger: "change" },
          ],

        },
        formData: {},
      },
    };
  },
  mounted() {
    this.getSignList();
  },
  methods: {
    // 获取活动记录
    getSignList() {
      const params = {
        pageNum: this.paginationInfo.pageNum,
        pageSize: this.paginationInfo.pageSize,
      };
      if (this.queryInfo.id) {
        params.id = this.queryInfo.id;
      }
      if (this.queryInfo.isStatus) {
        params.isStatus = this.queryInfo.isStatus;
      }
      console.log(params);
      this.$http
        .get("/sign/getPage", {
          params,
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            // 表格数据
            this.tableInfo.tableData = res.data.data.result;
            console.log(this.tableInfo.tableData)
            // 分页数据
            this.paginationInfo.pageNum = res.data.data.currPage;
            this.paginationInfo.pageSize = res.data.data.pageSize;
            this.paginationInfo.total = res.data.data.total;
          }
        });
    },

    // 打开新增/修改活动弹窗
    openDialog(row) {
      this.dialogInfo.visible = true;
      this.dialogInfo.formData = {};
      if (row.id) {
        // 修改活动
        this.dialogInfo.title = "修改签到";
        // console.log(row);
        // this.dialogInfo.formData["signTime"] = [];
        for (let key in row) {
          // if (key == "startTime") {
          //   this.dialogInfo.formData["signTime"].push(
          //     row["startTime"] ? row["startTime"].split(" ")[0] : ""
          //   );
          // } else if (key == "endTime") {
          //   this.dialogInfo.formData["signTime"].push(
          //     row["endTime"] ? row["endTime"].split(" ")[0] : ""
          //   );
          // }  else {
          //   // [key] = row[key];
          // }
          this.$set(this.dialogInfo.formData, key, row[key]);
        }
      } else {
        this.dialogInfo.title = "新增签到信息";


      }
    },

    // 切换每页展现的条数
    handleSizeChange(newSize) {
      this.paginationInfo.pageSize = newSize;
      this.getSignList();
    },

    // 切换页码
    handleCurrentChange(newPage) {
      this.paginationInfo.pageNum = newPage;
      this.getSignList();
    },

    // 自定义上传
    myUplaod(header) {
      if (header.data.name) {
        this.dialogInfo.formData[header.data.name] = header.file;
      }
    },

    // 移除文件
    removeFile(file) {
      for (let key in this.dialogInfo.formData) {
        if (
          this.dialogInfo.formData[key] instanceof File &&
          this.dialogInfo.formData[key].uid == file.uid
        ) {
          delete this.dialogInfo.formData[key];
        }
      }
    },

    // 新增活动
    addActivity() {
      this.$refs["activityForm"].validate((valid) => {
        // 判断是否通过验证
        if (valid) {
          const params = this.dialogInfo.formData;
          // params.beginDate = params.signTime[0]; // 获取开始时间
          // params.endDate = params.signTime[1]; // 获取结束时间
          // delete params.signTime;
          for(let key in params){
            if(params[key] == null || key == 'createTime' || key == 'updateTime'){
              delete params[key];
            }else if (key == 'startTime'){
              params.beginDate = params[key];
              delete params[key];
            }else if (key == 'endTime'){
              params.endDate = params[key];
              delete params[key];
            }
          }
          // 是否进行update操作
          let interfaceStr = '';
          if(this.dialogInfo.title == '修改签到'){

            interfaceStr = '/sign/update';
          }else if(this.dialogInfo.title == '新增签到信息'){
            interfaceStr = '/sign/save';
          }

          // 构造传参参数
          let formData = new FormData();
          for (let key in params) {
           if (key == "icon") {
              // params['bannerCoverFile'] = params([key]);
              formData.append(key + 'File', params[key]);
            } else {
              formData.append(key, params[key]);
            }
          }
          if (formData.get("rewardType") == 2){
              formData.append("day",7);
          }

          this.$http.post(interfaceStr, formData).then((res) => {
            console.log(res);
            if (res.status == 200) {
              if (res.data.code == 200) {
                // 操作成功
                this.$message.success(res.data.message);
                this.dialogInfo.visible = false;
                this.getSignList();
              } else {
                // 操作失误
                this.$message.error(res.data.message);
              }
            }
          });


        }
      });
    },

    // 删除活动
    async deleteSign(id) {
      console.log(1);
      //弹框提示是否删除
      const confirmResult = await this.$confirm(
        "此操作将永久删除该分类, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      //取消删除
      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除");
      }

      this.$http.delete("/sign/delete?id=" + id).then((res) => {
        if (res.status == 200) {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.getSignList();
          } else {
            this.$message.error(res.data.message);
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.cell img {
  width: 100%;
}
.el-col-1 {
  margin: 0 10px;
}
.el-range-editor.el-input__inner {
  width: 100%;
}
/deep/.el-dialog {
  min-width: 500px !important;
}
.el-input{
  width: 100%;
}
</style>
